<table class="table table-dark table-striped bg-transparent" mat-table [dataSource]="shows">

  <ng-container matColumnDef="icon">
    <th class="border-0 align-middle" mat-header-cell *matHeaderCellDef>Icon</th>
    <td class="border-0 align-middle" mat-cell *matCellDef="let show">
      <ng-container *ngIf="show.showIcon">
        <div class="backgroundImageListShows mt-2" [ngStyle]="{'background-image': 'url(' + media + show.showIcon + ')' }"></div>
      </ng-container>
      <ng-container *ngIf="!show.showIcon">
        <span class="material-icons display-2 mb-0 text-white-50">image_not_supported</span>
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th class="border-0 align-middle" mat-header-cell *matHeaderCellDef>Nazwa kategorii</th>
    <td class="border-0 align-middle" mat-cell *matCellDef="let show">
      <ng-container *ngIf="show.showName">
        {{show.showName}}
      </ng-container>
      <ng-container *ngIf="!show.showName">
        -
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="listProduct">
    <th class="border-0 align-middle" mat-header-cell *matHeaderCellDef>Liczba produktów dodanych do pokazu</th>
    <td class="border-0 align-middle" mat-cell *matCellDef="let show">
      <ng-container *ngIf="show.showProducts">
        {{show.showProducts.length}}
      </ng-container>
      <ng-container *ngIf="!show.showProducts">
        -
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th class="border-0 text-right align-middle" mat-header-cell *matHeaderCellDef>Akcje</th>
    <td class="border-0 text-right align-middle" mat-cell *matCellDef="let show">
      <ul class="list-inline mb-0">
        <li class="list-inline-item">
          <button
            routerLink="/dashboard/panel/edit-shows/{{show.id}}"
            mat-icon-button class="text-success">
            <span class="material-icons">edit</span>
          </button>
        </li>
        <li class="list-inline-item">
          <button
            (click)="delete(show.id)"
            mat-icon-button class="text-danger">
            <span class="material-icons">delete</span>
          </button>
        </li>
      </ul>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
